

import React, { useState } from 'react';
import { EnvelopeIcon, PhoneIcon, MapPinIcon } from '@heroicons/react/24/outline'
import bgImg from "../Assets/Images/property4.jpg"

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });
  const [isSending, setIsSending] = useState(false);
  const [statusMessage, setStatusMessage] = useState('');
  const [isError, setIsError] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSending(true);
    setStatusMessage('');
    setIsError(false);

    try {
      const response = await fetch(
        'https://ramadreamsgroup-server.vercel.app/send-email',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        }
      );

      if (!response.ok) {
        throw new Error('Failed to send message.');
      }

      setStatusMessage('Message sent successfully.');
      setFormData({ name: '', email: '', message: '' });
      setShowSuccessModal(true);
    } catch (error) {
      setIsError(true);
      setStatusMessage('Unable to send message right now. Please try again.');
    } finally {
      setIsSending(false);
    }
  };

  return (
    
    <div className="bg-gray-100 min-h-screen">
      <div className="relative bg-secondaryx h-96">
        <img
          className="absolute inset-0 w-full h-full object-cover mix-blend-overlay"
          src={bgImg}
          alt="RamaDreams office in Nigeria"
        />
        <div className="absolute inset-0 bg-secondaryx bg-opacity-75"></div>
        <div className="relative max-w-7xl mx-auto py-24 px-4 sm:py-32 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl">Contact Us</h1>
          <p className="mt-6 text-xl text-blue-100 max-w-3xl">
            We're here to listen, help, and make a difference. Reach out to us and be a part of our mission to create positive change.
          </p>
        </div>
      </div>


      <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
       
          <div className="bg-white shadow-md shadow-white rounded-lg p-8">
            <h2 className="text-2xl font-roboto text-secondary mb-6">Send us a message</h2>
            <form className="space-y-6" onSubmit={handleSubmit}>
              <div>
                <label htmlFor="name" className="block text-sm font-medium py-2 text-gray-700">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="mt-1 block w-full border-primary rounded-md shadow-sm py-4 px-4 border-[1.2px] focus:ring-blue-500 focus:border-blue-500"
                  required
                />
              </div>
              <div>
                <label htmlFor="email" className="block text-sm font-medium py-2 text-gray-700">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="mt-1 block w-full border-primary rounded-md shadow-sm py-4 px-4 border-[1.2px] focus:ring-blue-500 focus:border-blue-500"
                  required
                />
              </div>
              <div>
                <label htmlFor="message" className="block text-sm font-medium py-2 text-gray-700">Message</label>
                <textarea
                  id="message"
                  name="message"
                  rows="4"
                  value={formData.message}
                  onChange={handleChange}
                  className="mt-1 block w-full border-primary rounded-md shadow-sm py-4 px-4 border-[1.2px] focus:ring-blue-500 focus:border-blue-500"
                  required
                ></textarea>
              </div>
              {statusMessage ? (
                <p
                  className={`text-sm ${
                    isError ? 'text-red-600' : 'text-green-600'
                  }`}
                >
                  {statusMessage}
                </p>
              ) : null}
              <div>
                <button
                  type="submit"
                  disabled={isSending}
                  className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary hover:bg-secondary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-70 disabled:cursor-not-allowed"
                >
                  {isSending ? 'Sending...' : 'Send Message'}
                </button>
              </div>
            </form>
          </div>

        
          <div className="bg-gray-50 rounded-lg p-8">
            <h2 className="text-2xl font-roboto text-secondary mb-6">Get in touch</h2>
            <div className="space-y-6">
              <div className="flex items-center">
                <EnvelopeIcon className="h-6 w-6 text-blue-600 mr-3" />
                <span className="text-gray-600">ramadreamsgroup@gmail.com</span>
              </div>
              <div className="flex items-center">
                <PhoneIcon className="h-6 w-6 text-blue-600 mr-3" />
                <span className="text-gray-600">+234 905 989 8242</span>
              </div>
              <div className="flex items-center">
                <MapPinIcon className="h-6 w-6 text-blue-600 mr-3" />
                <span className="text-gray-600">Plot 959, Area 7, Garki Abuja, Nigeria</span>
              </div>
            </div>
            <div className="mt-8">
              <img
                className="w-full h-48 object-cover rounded-lg"
                src="https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=1469&q=80"
                alt="RamaDreams office in Nigeria"
              />
            </div>
          </div>
        </div>
      </div>
 
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-16">
        <div className="bg-white shadow-xl shadow-white rounded-lg overflow-hidden">
          <iframe
            title="RamaDreams Location"
            className="w-full h-96"
            src="https://www.google.com/maps?q=Abuja%20Nigeria&output=embed"
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
      </div>
      {showSuccessModal ? (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4"
          role="dialog"
          aria-modal="true"
          aria-labelledby="contact-success-title"
        >
          <div className="w-full max-w-md rounded-lg bg-white p-6 shadow-2xl">
            <h3
              id="contact-success-title"
              className="text-xl font-semibold text-secondary"
            >
              Message sent!
            </h3>
            <p className="mt-3 text-sm text-gray-600">
              Thanks for reaching out. We will get back to you soon.
            </p>
            <div className="mt-6 flex justify-end">
              <button
                type="button"
                onClick={() => setShowSuccessModal(false)}
                className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-white hover:bg-secondary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default Contact;
